/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Array of the credential subject data (DidIssuer, CredentialName, CredentialType, LevelOfAssurance, Keys[] and Values[].
 */
export interface CredentialDataCommonResult { 
    /**
     * DID of the issuer who signed the credential.
     */
    didIssuer?: string;
    /**
     * Credential name, for example: \'Employee\' or \'Fan\' or ...
     */
    credentialName?: string;
    /**
     * Credential type, possible settings: \'AlastriaVerifiableCredential\' (by default) or \'W3CVeriableCredential\'.
     */
    credentialType?: string;
    /**
     * Credential level of assurance, possible settings: \'LOW\' (by default), \'SUBSTANTIAL\' or \'HIGH\'.
     */
    levelOfAssurance?: string;
    /**
     * Keys of the subject data, for example: \'EmployeeId\' or \'EmployeeNumber\' or \'FanId\' or \'AccountType\'...
     */
    keys?: Array<string>;
    /**
     * Values of the subject data corresponding to the keys, for example: \'kQyOMRAB7A551VE3Wprhh2rvqUXn3Q1Fpa3jhXXE4p0\', \'25\', \'+34656254059\' or \'PREMIUM\'...
     */
    values?: Array<string>;
}

